import bankJPMorgan from '../../banksPNG/bankJPMorgan.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoJpMorganIcon = ({
	width = '17',
	height = '17',
	alt = 'Banco JP Morgan',
}: IconProps) => <img src={bankJPMorgan} width={width} height={height} alt={alt} />;
